module.exports = __webpack_public_path__ + "img/register.23d1bae7.jpg";